<template>
  <div class="account">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="#">我的账户</a></li>
        </ul>
      </nav>
    </div>
    <el-form :model="userItem" ref="ruleForm" :rules="userRule" label-width="120px" class="demo-ruleForm">
      <el-form-item label="您的昵称" prop="nickname">
        <el-input v-model="userItem.nickname" placeholder="您的昵称"></el-input>
      </el-form-item>
      <el-form-item label="真实姓名" prop="trueName">
        <el-input v-model="userItem.trueName" placeholder="真实姓名"></el-input>
      </el-form-item>
      <el-form-item label="您的性别" prop="sex">
        <el-radio-group v-model="userItem.sex">
          <el-radio :label="'m'">男</el-radio>
          <el-radio :label="'f'">女</el-radio>
          <el-radio :label="'s'">保密</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="邮箱地址" prop="email">
        <el-input v-model="userItem.email" placeholder="邮箱地址"></el-input>
      </el-form-item>
      <el-form-item label="所在地区" prop="region" class="addressxx">
        <el-select v-model="userItem.province" placeholder="请选择" @change="queryCities">
          <el-option v-for="item in provinces" :key="item.code" :label="item.name" :value="item.code">
          </el-option>
        </el-select>
        <el-select v-model="userItem.city" placeholder="请选择">
          <el-option v-for="item in cities" :key="item.code" :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上传头像" prop="image">
        <el-upload class="avatar-uploader" action="/dmc/file/uploadFile" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>选择上传文件<span style="color:red">(请选择小于2M的JPG和PNG格式文件)</span>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" plain @click="submitForm">更新资料</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'account',
  components: {
  },
  data() {
    return {
      userItem: {
        nickname: '',
        account: '',
        sex: '',
        email: '',
        trueName: '',
        province: '',
        city: '',
        avatarPath: ''
      },
      agent: '',
      provinces: [],
      cities: [],
      userRule: {
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        trueName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          { pattern: /^[\u0391-\uFFE5]+$/, message: '请输入中文' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { pattern: /^(?:[a-z0-9]+[_\-+.]?)*[a-z0-9]+@(?:([a-z0-9]+-?)*[a-z0-9]+\.)+([a-z]{2,})+$/i, message: '邮箱格式不正确' }
        ]
      },
      imageUrl: ''
    }
  },
  created() {
    let imageUrl = JSON.parse(sessionStorage.getItem('imageUrl'))
    if (imageUrl !== 'data:image/png;base64,') {
      this.imageUrl = imageUrl
    }
    this.loadAccount()
  },
  methods: {
    loadAccount() {
      this.sapost('/dmc/account/account', '', r => {
        let { retCode, retMsg, e, provinces, cities } = r.data
        if (retCode === '0') {
          Object.keys(this.userItem).map(key => {
            this.userItem[key] = e[key]
          })
          this.provinces = provinces
          this.cities = cities
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
        // 查询图片信息
        // var _this = this
        // _this.$http.get('/dmc/account/getAvatar', {
        //   params: {
        //     account: this.userItem.account
        //   },
        //   responseType: 'arraybuffer'
        // }).then(function (response) {
        //   // 将从后台获取的图片流进行转换
        //   return 'data:image/png;base64,' + btoa(
        //     new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
        //   )
        // }).then(function (data) {
        //   // 接收转换后的Base64图片
        //   _this.imageUrl = data
        // })
      })
    },
    queryCities(item) {
      this.userItem.city = null
      this.userItem.area = null
      let queryParam = { provinceCode: item }
      this.sapost('/dmc/address/selectCitysByProvinceCode', queryParam, r => {
        this.cities = r.data
      })
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let e = JSON.stringify(this.userItem)
          this.$http({
            method: 'post',
            url: '/dmc/account/saveSetting',
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: e
          }).then(r => {
            let { retMsg, retCode, e } = r.data
            if (retCode === '0') {
              this.loadAccount()
              this.$emit('changeUser', this.userItem)
              let sessionUser = JSON.parse(sessionStorage.getItem('user'))
              sessionUser.nickName = e.nickname
              sessionUser.sex = e.sex
              sessionStorage.setItem('user', JSON.stringify(sessionUser))
              this.$message.success(retMsg)
            } else {
              this.$message.warning(retMsg)
            }
            sessionStorage.setItem('imageUrl', JSON.stringify(this.imageUrl))
            eventBus.$emit('showAvatar')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.userItem.avatarPath = res.realPath
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是JPG和PNG格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过2MB!')
      }
      return isLt2M
    }
  }
}
</script>

<style lang="less">
.account {
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  min-height: 500px;
  .t-nav {
    nav {
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 150px;
        height: 60px;
        color: #b4b8bb;
        li {
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a {
            color: #b4b8bb;
          }
        }
        li.active,
        li:hover {
          border-bottom: 2px solid #f01400;
          a {
            color: #f01400;
          }
        }
      }
    }
  }
  .demo-ruleForm {
    overflow: hidden;
    margin-top: 25px;
    .el-select {
      width: 186px;
    }
    .addressxx {
      .el-input__inner {
        width: 100%;
      }
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #e01126;
      background: #e01126;
    }
    .el-radio__inner:hover {
      border-color: #e01126;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #333;
    }
    label {
      text-align: left;
    }
    input {
      width: 50%;
    }
    button {
      margin-left: 276px;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/account.vue